import React, { useContext } from 'react';
import {Modal} from 'antd'
import { AppContext } from '../../Context/AppProvider';

function NotificationRemoveRoom(props) {
      const {isNotificationRemoveRoom, setIsNotificationRemoveRoom} = useContext(AppContext);
      const handleOnCancel=()=>{
            setIsNotificationRemoveRoom(false);
      }
      return (
            <Modal
                  title='Thông báo'
                  visible={isNotificationRemoveRoom}
                  onOk={handleOnCancel}
                  onCancel={handleOnCancel}
            >
                  <div className='text-notification'>Bạn không phải là Admin của nhóm Chat!</div>
            </Modal>
      );
}

export default NotificationRemoveRoom;